/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Remove_NumberInputs */

const en_cna_remove_number = /** @type {(inputs: Cna_Remove_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove number`)
};

const ja_cna_remove_number = /** @type {(inputs: Cna_Remove_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`番号を削除`)
};

const fr_cna_remove_number = /** @type {(inputs: Cna_Remove_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le numéro`)
};

const de_cna_remove_number = /** @type {(inputs: Cna_Remove_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nummer entfernen`)
};

/**
* | output |
* | --- |
* | "Remove number" |
*
* @param {Cna_Remove_NumberInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_remove_number = /** @type {((inputs?: Cna_Remove_NumberInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Remove_NumberInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_remove_number(inputs)
	if (locale === "ja") return ja_cna_remove_number(inputs)
	if (locale === "fr") return fr_cna_remove_number(inputs)
	return de_cna_remove_number(inputs)
});